import Vue from 'vue'
import Main from './main.vue'

let MsgConstructor = Vue.extend(Main)

const Msg = options => {
  options = options || {}
  let data = Object.assign({}, options, {
    afterClose: vm => {
      if (typeof options?.afterClose === 'function') {
        options.afterClose()
      }
      // vm.$destroy()
    }
  })
  let instance = new MsgConstructor({
    data: data
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  return instance
}

export default Msg
